<div class="right-side p-5">
  <div class="section">
    <form [formGroup]="eventUpdationForm">
      <div class="card mb-3">
        <div class="card-header">
          <h2 class="text-start">Upload Event Photo:</h2>
        </div>
        <div class="card-body">
          <div formArrayName="documents">
            <div
              *ngFor="let doc of documents.controls; let i = index"
              [formGroupName]="i"
            >
              <div class="row text-start mb-3">
                <div class="col-md-4">
                  <label class="nowrap" for="name{{ i }}">Document Name:</label>
                  <input
                    id="name{{ i }}"
                    class="form-control"
                    formControlName="name"
                    placeholder="Enter Document Name"
                  />


                  <div
                    *ngIf="doc.get('name')?.invalid && doc.get('name')?.touched"
                  >
                    <small class="text-danger"
                      >Document name is required.</small
                    >
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="nowrap" for="docFile{{ i }}"
                    >Upload File ( max 5 MB):</label
                  >
                  <input
                    type="file"
                    id="docFile{{ i }}"
                    (change)="onFileChange($event, i)"
               
                    class="form-control"
                  />

                  <div *ngIf="doc.get('filePath')?.value" class="mt-1">
                    <a
                      class="text-primary fw-bold"
                      style="
                        cursor: pointer;
                        text-decoration: underline;
                        font-size: 13px;
                      "
                      (click)="viewExistingFile(doc.get('filePath')?.value)"
                    >
                      <i class="bi bi-eye-fill"></i> View  File
                    </a>
                  </div>

                  <div *ngIf="doc.get('file')?.touched" class="text-danger">
                    <div
                      *ngIf="doc.get('file')?.errors?.['required']"
                      class="text-danger"
                    >
                      PDF/PNG/JPG File is required.
                    </div>
                    <div
                      *ngIf="doc.get('file')?.errors?.['invalidType']"
                      class="text-danger"
                    >
                      Only PDF, PNG, and JPG files are allowed.
                    </div>
                    <div
                      *ngIf="doc.get('file')?.errors?.['maxSize']"
                      class="text-danger"
                    >
                      File size should not exceed 10MB.
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <button
                    type="button"
                    class="btn btn-danger btn-sm mt-4"
                    (click)="
                      onDelete(
                        'EventImages',
                        doc.get('rawDocName')?.value || doc.get('name')?.value,
                           doc.get('id')?.value,
                        i,
                        documents
                      )
                    "
                  >
                    <i class="bi bi-trash"></i> Remove
                  </button>
                  <div
                    *ngIf="removedocumentuploadError"
                    class="text-danger mt-2"
                  >
                    {{ removedocumentuploadError }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-start">
            <button
              type="button"
              class="btn btn-primary text-start"
              (click)="addMoreDocuments()"
              [disabled]="documents.length >= 5"
            >
              Add More
            </button>
          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-header">
          <h2 class="text-start">Upload Attendance Sheet:</h2>
        </div>
        <div class="card-body">
          <div class="row">
            <div formArrayName="attendance">
              <div
                *ngFor="let doc of attendance.controls; let i = index"
                [formGroupName]="i"
              >
                <div class="row text-start mb-3">
                  <div class="col-md-4">
                    <label class="nowrap" for="docAttendanceName{{ i }}"
                      >Document Name:</label
                    >
                    <input
                      id="docAttendanceName{{ i }}"
                      class="form-control"
                      formControlName="docAttendanceName"
                      placeholder="Enter Document Name"
                    />
                    <div
                      *ngIf="
                        doc.get('docAttendanceName')?.invalid &&
                        doc.get('docAttendanceName')?.touched
                      "
                    >
                      <small class="text-danger"
                        >Document name is required.</small
                      >
                    </div>
                  </div>

                  <div class="col-md-4">
                    <label class="nowrap" for="docAttendanceFile{{ i }}"
                      >Upload File ( max 5 MB):</label
                    >
                    <input
                      type="file"
                      id="docAttendanceFile{{ i }}"
                      (change)="onAttendanceFileChange($event, i)"
                      accept=".pdf"
                      class="form-control"
                    />

                    <div *ngIf="doc.get('filePath')?.value" class="mt-1">
                      <a
                        class="text-primary fw-bold"
                        style="
                          cursor: pointer;
                          text-decoration: underline;
                          font-size: 13px;
                        "
                        (click)="viewExistingFile(doc.get('filePath')?.value)"
                      >
                        <i class="bi bi-eye-fill"></i> View  File
                      </a>
                    </div>

                    <div *ngIf="doc.get('file')?.touched" class="text-danger">
                      <div
                        *ngIf="doc.get('file')?.errors?.['required']"
                        class="text-danger"
                      >
                        PDF/PNG/JPG File is required.
                      </div>
                      <div
                        *ngIf="doc.get('file')?.errors?.['invalidType']"
                        class="text-danger"
                      >
                        Only PDF file is allowed.
                      </div>
                      <div
                        *ngIf="doc.get('file')?.errors?.['maxSize']"
                        class="text-danger"
                      >
                        File size should not exceed 10MB.
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <button
                      type="button"
                      class="btn btn-danger btn-sm mt-4"
                      (click)="
                        onDelete(
                          'EventAttendance',
                          doc.get('rawDocName')?.value ||
                            doc.get('docAttendanceName')?.value,  doc.get('id')?.value,
                          i,
                          attendance
                        )
                      "
                    >
                      <i class="bi bi-trash"></i> Remove
                    </button>
                    <div *ngIf="uploadAttError" class="text-danger mt-2">
                      {{ uploadAttError }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-start mb-2">
              <button
                type="button"
                class="btn btn-primary text-start"
                (click)="addMoreAttendanceDocuments()"
                [disabled]="attendance.length >= 5"
              >
                Add More
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-header">
          <h2 class="text-start">Upload Other Documents:</h2>
        </div>

        <div class="card-body">
          <div formArrayName="otherDocuments">
            <div
              *ngFor="let doc of otherDocuments.controls; let i = index"
              [formGroupName]="i"
            >
              <div class="row text-start mb-3">
                <div class="col-md-4">
                  <label class="nowrap" for="otherDocName{{ i }}"
                    >Document Name:</label
                  >
                  <input
                    id="otherDocName{{ i }}"
                    class="form-control"
                    formControlName="documentName"
                    placeholder="Enter Document Name"
                  />
                  <div
                    *ngIf="
                      doc.get('documentName')?.invalid &&
                      doc.get('documentName')?.touched
                    "
                  >
                    <small class="text-danger"
                      >Document name is required.</small
                    >
                  </div>
                </div>

                <div class="col-md-4">
                  <label class="nowrap" for="otherDocFile{{ i }}"
                    >Upload File (max 5 MB):</label
                  >
                  <input
                    type="file"
                    id="otherDocFile{{ i }}"
                    class="form-control"
                    accept=".pdf,.png,.jpg,.jpeg"
                    (change)="onOtherDocumentFileChange($event, i)"
                  />



                  <div *ngIf="doc.get('filePath')?.value" class="mt-1">
                    <a
                      class="text-primary fw-bold"
                      style="
                        cursor: pointer;
                        text-decoration: underline;
                        font-size: 13px;
                      "
                      (click)="viewExistingFile(doc.get('filePath')?.value)"
                    >
                      <i class="bi bi-eye-fill"></i> View  File
                    </a>
                 
                  </div>
                  

                  <div *ngIf="doc.get('file')?.touched" class="text-danger">
                    <div *ngIf="doc.get('file')?.errors?.['required']">
                      File is required.
                    </div>
                    <div *ngIf="doc.get('file')?.errors?.['invalidType']">
                      Only PDF, PNG and JPG files are allowed.
                    </div>
                    <div *ngIf="doc.get('file')?.errors?.['maxSize']">
                      File size should not exceed 10MB.
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <button
                    type="button"
                    class="btn btn-danger btn-sm mt-4"
                    (click)="
                      onDelete(
                        'OtherDocuments',
                        doc.get('rawDocName')?.value ||
                          doc.get('documentName')?.value,
                             doc.get('id')?.value,
                        i,
                        otherDocuments
                      )
                    "
                  >
                    <i class="bi bi-trash"></i> Remove
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="text-start">
            <button
              type="button"
              class="btn btn-primary"
              (click)="addMoreOtherDocuments()"
              [disabled]="otherDocuments.length >= 5"
            >
              Add More
            </button>
          </div>

          <div class="text-center mt-3">
            <button
              type="submit"
              class="btn btn-success me-2"
              (click)="onSubmit()"
              [disabled]="isSubmitting"
            >
              Submit
            </button>
            <button
              id="btncancel"
              type="reset"
              class="btn btn-info"
              [routerLink]="'/Update-Upload-Documents'"
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
